/**
 * Onboarding domain agent ID.
 *
 * Agent registration and tool configuration now live server-side (Genaisis Python API).
 * The frontend only needs the agent ID to tell the backend which agent to activate.
 */
export const ONBOARDING_AGENT_ID = 'onboarding'
